import { Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import UseTranslation from '../../hooks/UseTranslation'

const TitleWithCount = ({ pageName, store, customStyles }) => {
  const [pageCount, setPageCount] = useState(0)
  const { t } = UseTranslation()
  useEffect(() => {
    setPageCount(store?.summaries ? store?.summaries[store?.activeSummary?.toLowerCase()] : 0)
  }, [store])

  return (
    <Typography variant="h5" sx={[styles.root, customStyles]}>
       <span>{pageName}</span>   {` ${t?.Showing} ${pageCount} ${t?.Available} ${pageName}`}
    </Typography>
  )
}

const styles = {
  root: {
    fontSize: { xs: '14px', sm: '18px' },
    color: 'text.secondary',
    textTransform: 'capitalize',
    marginBottom: { xs: '10px', sm: '15px' },
    marginTop: '2%',
    span: {
      color: 'text.primary',
      fontSize: { xs: '14px', sm: '28px' },
      marginRight: '20px',
    },
  },
}

export default TitleWithCount
